"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserSessionState = exports.selectUserSessionJourneyStatus = exports.selectUserSession = exports.selectProcessFlowId = exports.selectMarketingId = exports.selectIsUserSessionLoaded = exports.selectIsUserSessionFinalized = exports.selectIsSavingUserSession = void 0;
var _constants = require("../../utils/constants");
var _widgetSelectors = require("../widget/widgetSelectors");
var _shareRecommendationSelectors = require("../shareRecommendation/shareRecommendationSelectors");
var _recommendationSelectors = require("../recommendation/recommendationSelectors");
var _uiSelectors = require("../ui/uiSelectors");
const selectMarketingId = instanceId => state => {
  return state.drools[instanceId].user.marketingId;
};
exports.selectMarketingId = selectMarketingId;
const selectProcessFlowId = instanceId => state => {
  var _state$drools$instanc;
  return (_state$drools$instanc = state.drools[instanceId].user.userSession) === null || _state$drools$instanc === void 0 ? void 0 : _state$drools$instanc.id;
};
exports.selectProcessFlowId = selectProcessFlowId;
const selectIsUserSessionLoaded = instanceId => state => {
  return state.drools[instanceId].user.isUserSessionLoaded;
};
exports.selectIsUserSessionLoaded = selectIsUserSessionLoaded;
const selectIsUserSessionFinalized = instanceId => state => {
  return state.drools[instanceId].user.isUserSessionFinalized;
};
exports.selectIsUserSessionFinalized = selectIsUserSessionFinalized;
const selectIsSavingUserSession = instanceId => state => {
  return state.drools[instanceId].user.isSavingUserSession;
};
exports.selectIsSavingUserSession = selectIsSavingUserSession;
const selectUserSessionState = instanceId => (state, stateMetadata, questionIndex) => {
  const {
    questionnaire
  } = state.drools[instanceId];
  const settings = (0, _widgetSelectors.selectTransformedSettings)(instanceId)(state);
  const shareRecommendation = (0, _shareRecommendationSelectors.selectShareRecommendationData)(instanceId)(state);
  const {
    selections,
    answers,
    questions
  } = questionnaire;
  const recommendationRawData = (0, _recommendationSelectors.selectRecommendationRawData)(instanceId)(state);
  const selectedHandsetId = (0, _recommendationSelectors.selectSelectedHandsetId)(instanceId)(state);
  const selectedPlanId = (0, _recommendationSelectors.selectSelectedPlanId)(instanceId)(state);
  const selectedBroadbandId = (0, _recommendationSelectors.selectSelectedBroadbandId)(instanceId)(state);
  const ratingData = (0, _recommendationSelectors.selectRating)(instanceId)(state);
  const questionTitles = questions.map(question => {
    return question.title;
  });
  const timestamps = (0, _uiSelectors.selectTimestamps)(instanceId)(state);
  return {
    questionnaire: {
      currentQuestionIndex: questionIndex,
      selections,
      answers,
      questionTitles
    },
    recommendation: {
      recommendationRawData,
      selectedHandsetId,
      selectedPlanId,
      selectedBroadbandId,
      ratingData
    },
    stateMetadata: {
      ...stateMetadata,
      settings,
      shareRecommendation
    },
    timestamps
  };
};
exports.selectUserSessionState = selectUserSessionState;
const selectUserSession = instanceId => state => {
  return state.drools[instanceId].user.userSession;
};
exports.selectUserSession = selectUserSession;
const selectUserSessionJourneyStatus = instanceId => state => {
  var _userSession$characte;
  const userSession = selectUserSession(instanceId)(state);
  if (!userSession) {
    return _constants.USER_SESSION_JOURNEY_STATUS.NEW_USER;
  }
  const serializedSessionState = (_userSession$characte = userSession.characteristic.find(item => item.name === 'questionnaireState')) === null || _userSession$characte === void 0 ? void 0 : _userSession$characte.value;
  if (!serializedSessionState || serializedSessionState === '{}') {
    return _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_START;
  }
  const sessionState = JSON.parse(serializedSessionState);
  if (sessionState.questionnaire.currentQuestionIndex === _constants.RECOMMENDATION_PAGE_INDEX) {
    return _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_RECOMMENDATION;
  }
  return _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_QUESTIONNAIRE;
};
exports.selectUserSessionJourneyStatus = selectUserSessionJourneyStatus;